import React from 'react'
import {bemClassName, blockClassesConcat, elementClassesConcat} from 'bem-components-connector'


import './style.scss';

export const PageHeader = ({title, subtitle}) => {

    const block = bemClassName('page-header')

        return (
        <div className={block()}>
            <h1 className={block('title')}>
                {title}
            </h1>
            {subtitle ? (<span className={block('sub-title')}>{subtitle}</span>) : null}
        </div>
    )
}